// total Inventory State

export default {
  totalInventoryShortageList: [],
  totalInventoryShortageCount: 0
}
